module.exports = __webpack_public_path__ + "static/media/swap.95e98e68.svg";